import React from 'react';
import TeamManagementComponent from '@/components/organisms/TeamManagement';

const TeamManagement: React.FC = () => {
  return (
    <div className="container">
      <TeamManagementComponent />
    </div>
  );
};

export default TeamManagement; 